export default {
  'dashboardandmonitor.monitor.trading-activity': '活动实时交易情况',
  'dashboardandmonitor.monitor.total-transactions': '今日交易总额',
  'dashboardandmonitor.monitor.sales-target': '销售目标完成率',
  'dashboardandmonitor.monitor.remaining-time': '活动剩余时间',
  'dashboardandmonitor.monitor.total-transactions-per-second': '每秒交易总额',
  'dashboardandmonitor.monitor.activity-forecast': '活动情况预测',
  'dashboardandmonitor.monitor.efficiency': '券核效率',
  'dashboardandmonitor.monitor.ratio': '跳出率',
  'dashboardandmonitor.monitor.proportion-per-category': '各品类占比',
  'dashboardandmonitor.monitor.fast-food': '中式快餐',
  'dashboardandmonitor.monitor.western-food': '西餐',
  'dashboardandmonitor.monitor.hot-pot': '火锅',
  'dashboardandmonitor.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboardandmonitor.monitor.popular-searches': '热门搜索',
  'dashboardandmonitor.monitor.resource-surplus': '资源剩余',
  'dashboardandmonitor.monitor.fund-surplus': '补贴资金剩余',
};
